import React from 'react';
import clsx from 'clsx';
import { CellMeasurer } from 'react-virtualized';
import { useTranslation } from 'react-i18next';

import HighlightedText from '../highlighted-text/HighlightedText';

import './CommonVirtualizedDropdown.scss';

const RowRenderer = ({
  index,

  style,
  parent,
  options,

  handleSelectOption,
  cellMeasurerCache,
  renderContentItem,
  isHighlighted,
  searchQuery,
  customListItemStyle,
  itemClassName,
}) => {
  const { t } = useTranslation();
  const option = options[index];
  const { label } = option;

  const listItemStyle = {
    ...style,
    ...(index - 1 !== options.length ? { marginBottom: 6 } : {}),
    ...customListItemStyle,
  };

  const handleSelect = () => {
    handleSelectOption(option);
  };

  return (
    <CellMeasurer cache={cellMeasurerCache} columnIndex={0} rowIndex={index} parent={parent}>
      <div style={listItemStyle}>
        {renderContentItem ? (
          renderContentItem({ option, searchQuery, onSelect: handleSelect })
        ) : (
          <div
            className={clsx(
              'common-virtualized-dropdown_item',
              !label && 'common-virtualized-dropdown_item--center',
              itemClassName,
            )}
            onClick={handleSelect}
            role='presentation'>
            {label ? <HighlightedText value={label} searchTerm={isHighlighted ? searchQuery : ''} /> : t('empty')}
          </div>
        )}
      </div>
    </CellMeasurer>
  );
};

export default RowRenderer;
